<template>
  <div class="page">
    <div class="page__bd">
      <div class="weui-gallery">
        <img
          crossorigin="anonymous"
          :src="imgUrl"
          id="weui-gallery__img"
          class="weui-gallery__img"
        />
        <div class="weui-gallery__tip">
          <p>可邀请同事加入云系统，长按图片分享。</p>
          <p>单击页面将关闭，后续可通过点击“我”→“邀请同事”邀请。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import session from "@/util/session.js";

export default {
  data() {
    return {
      imgUrl: null,
    }
  },
  mounted() {
    this.loadCard()
  },
  methods: {
    loadCard() {
      var me = this,
        companyName = session.get().account.defaultCompany.name
      me.$loading({
        url: '/api/commons/share/qrcode',
        method: "GET",
        responseType: 'blob',
        params: {
          basePath: window.location.origin,
          delay: 1,
          companyName
        }
      }).then(function (res) {
        const blob = new Blob([res])
        me.imgUrl = window.URL.createObjectURL(blob)
      })
    }
  }
}
</script>

<style scoped>
.page {
  z-index: 1000;
  background: white;
}
.weui-gallery {
  background-color: inherit;
  display: block;
  top: 20px;
  bottom: 20px;
  left: 20px;
  right: 20px;
}

.weui-gallery__tip {
  position: absolute;
  bottom: calc(60px + env(safe-area-inset-bottom));
  width: 100%;
  color: var(--weui-FG-1);
  text-align: center;
}
</style>